import { ImgHost } from './services/urlService'

export const getImgUrl = (url) => {
  if (url) {
    return `${ImgHost}${url}`
  }
  return ''
}

export const bookStatus = (val) => {
  return {
    serialize: '连载中',
    finish: '已完结'
  }[val]
}
